import { createContext, useContext } from 'react';
import { PageShellContextValue } from './types';

export const PageShellContext = createContext<PageShellContextValue | null>(null);

export const usePageShellContext = (): PageShellContextValue => {
  const context = useContext(PageShellContext);

  if (!context) {
    throw new Error('PageShell sections must be used within PageShell.');
  }

  return context;
};